/*
 * @Author: edvardchen
 * @Date:   2016-12-06 11:07:18
 * @Last Modified by: qiyuanchen
 * @Last Modified time: 2019-12-05 20:59:46
 */
// @flow
import _ from 'lodash';
import { connect } from 'react-redux';
import React from 'react';
// import Portal from 'react-overlays/lib/Portal';
import autobind from 'core-decorators/lib/autobind';

import Modal from '../components/Modal';

import {
  updateStatus as updateInstallStatus,
  showMask,
  hideMask,
  showDBBar,
  // hideDBBar,
  sharelpModal,
} from '../actions/installer';

import contextTypes from '../components/Share/contextTypes';
import DBMask from '../components/Share/DBMask';
// import Hongbao from '../components/Share/Hongbao';
import DownloadBar from '../components/DownloadBarForShare'; // 分享框架页面单独抽离出来组件
import ShareModal from '../components/Share/ShareModal';

import {
  onVisibilityChange,
  isWeChat,
  isIOS,
  listenToScroll,
  // hasReachedBottom,
} from '../utility';
import {
  detectStatus,
  download,
  // loadStatus,
  openQb,
  onShare,
  addSharePower,
  checkAndroidQB,
  downloadOrOpenQb,
} from '../utility/QBDownload';
type Props = {
  dispatch: Function,
  installed: boolean,
  showModal: boolean,
  installMask: {
    show: boolean,
    label: string,
  },
};
const reachBottom = () => window.pageYOffset + window.innerHeight > document.body.offsetHeight - 10;

// const delay = 3000;

const createDecorator = (withDB) =>
  function withShareContextForShare(WrappedComponent) {
    // inject contextTypes
    /* eslint-disable no-param-reassign */
    WrappedComponent.contextTypes = WrappedComponent.contextTypes || {};
    Object.assign(WrappedComponent.contextTypes, contextTypes);

    class ContainerWithShareContext extends React.PureComponent<Props> {
      statusWatch: {
        remove: Function,
      };

      scrollWatch: {
        remove: Function,
      };

      DBTimer: number; // 显示下载 mask 之后创建的定时器

      static displayName = `${WrappedComponent.displayName || WrappedComponent.name}WithShareContext`;

      static childContextTypes = contextTypes;

      static defaultProps = {
        installMask: {
          show: false,
        },
      };

      state = {};

      getChildContext() {
        return {
          openQb,
          downloadOrOpenQb: this.downloadOrOpenQb,
          download: this.download,
          onShare,
          setDownloadBar: this.setDownloadBar,
          addSharePower,
          checkAndroidQB,
        };
      }

      componentDidMount() {
        this.checkInstallStatus();
        this.statusWatch = onVisibilityChange((event, hidden) => {
          if (!hidden) {
            // update status
            this.checkInstallStatus();
          }
        });
        this.scrollWatch = listenToScroll(() => {
          if (reachBottom()) {
            this.props.dispatch(showDBBar());
          }
        });
        import(/* webpackChunkName: "hammerjs" */ 'hammerjs').then(() => {
          const { Hammer } = window;
          const mc = new Hammer.Manager(document.body, {
            touchAction: 'pan-y',
          });

          mc.add(
            new Hammer.Pan({
              direction: Hammer.DIRECTION_VERTICAL,
              // threshold: 20,
            }),
          );

          const handle = _.throttle(
            ({ type }) => {
              switch (type) {
                case 'panup':
                  // this.props.dispatch(hideDBBar());
                  break;
                case 'pandown':
                  // this.props.dispatch(showDBBar());
                  break;
                default:
                  break;
              }
            },
            500,
            { trailing: false },
          );

          mc.on('pandown', handle);
          mc.on('panup', handle);
        });
      }

      componentWillUnmount() {
        this.statusWatch && this.statusWatch.remove();
        this.scrollWatch && this.scrollWatch.remove();
      }

      checkInstallStatus() {
        detectStatus().then((status) => {
          this.props.dispatch(updateInstallStatus(status));
        });
      }

      @autobind
      download(label: string) {
        const { userAgent } = navigator;
        if (isWeChat(userAgent) && isIOS(userAgent)) {
          download({
            label,
            dispatchFunc: this.props.dispatch,
          });
          return;
        }
        this.props.dispatch(showMask(label));
      }

      @autobind
      downloadOrOpenQb({ label, url, hideMaskModal }) {
        this.setState({
          redirectUrl: url,
        });
        console.log('this.props.installed', this.props.installed);
        if (this.props.installed) {
          openQb({
            label,
            url,
          });
        } else if (hideMaskModal) {
          download({
            label,
            dispatchFunc: this.props.dispatch,
            url,
          });
        } else {
          this.download({
            label,
          });
        }
      }

      @autobind
      onDownload(event) {
        event.stopPropagation();
        this.DBTimer && clearTimeout(this.DBTimer);
        download({
          label: this.props.installMask.label,
          dispatchFunc: this.props.dispatch,
        });
      }

      @autobind
      closeDBMask(event) {
        event.stopPropagation();
        this.DBTimer && clearTimeout(this.DBTimer);
        this.props.dispatch(hideMask());
      }

      @autobind
      setDownloadBar(props) {
        this.setState({
          DownloadBarProps: props,
        });
      }

      @autobind
      modalCancle() {
        this.props.dispatch(sharelpModal(false));
      }
      @autobind
      modalSubmint() {
        this.props.dispatch(sharelpModal(false));
        downloadOrOpenQb();
      }

      render() {
        const { showModal } = this.props;
        return (
          <div>
            <WrappedComponent {...this.props} />
            <Modal contentLabel="download modal" onRequestClose={this.closeDBMask} isOpen={this.props.installMask.show}>
              <DBMask onDownload={this.onDownload} onClose={this.closeDBMask} />
            </Modal>
            {withDB && <DownloadBar {...this.state.DownloadBarProps} />}
            {showModal && <ShareModal onCancle={this.modalCancle} onSubmit={this.modalSubmint} />}
          </div>
        );
      }
    }

    return connect(({ installer: { installed, installMask, showModal } }) => ({
      installed,
      installMask,
      showModal,
    }))(ContainerWithShareContext);
  };

export default createDecorator(true); // 默认是带 DownloadBar
export const withoutDB = createDecorator(false);
